import { useWalletAccess } from '@/features/wallet-access/wallet-access-provider';

export enum UserSuiWalletStatus {
  LOADING = 'loading',
  PROVISIONING = 'provisioning',
  NOT_STARTED = 'not_started',
  READY = 'ready',
  ERROR = 'error',
}

export type UserSuiWalletState =
  | { status: UserSuiWalletStatus.READY; address: string }
  | { status: Exclude<UserSuiWalletStatus, UserSuiWalletStatus.READY>; address?: undefined };

export const PRIVY_API_URL = 'https://api.privy.io/v1';

export function usePrivyWallet(): UserSuiWalletState {
  const { access, isLoading, isBusy, error } = useWalletAccess();

  if (access?.address) {
    return { status: UserSuiWalletStatus.READY, address: access.address };
  }

  if (isBusy) {
    return { status: UserSuiWalletStatus.PROVISIONING };
  }

  if (error) {
    return { status: UserSuiWalletStatus.ERROR };
  }

  return { status: isLoading ? UserSuiWalletStatus.LOADING : UserSuiWalletStatus.NOT_STARTED };
}
